import { apiClient } from './apiClient';

export const getActivityLogs = async (params = {}) => {
  const { page = 0, size = 20, search = '', method = '', success, from = '', to = '' } = params;
  const queryParams = new URLSearchParams();
  queryParams.append('page', page);
  queryParams.append('size', size);
  if (search) queryParams.append('search', search);
  if (method) queryParams.append('method', method);
  if (success !== undefined && success !== '') queryParams.append('success', success);
  if (from) queryParams.append('from', from);
  if (to) queryParams.append('to', to);
  return await apiClient(`/admin/activity-logs?${queryParams.toString()}`, { method: 'GET' }, true);
};

export const getActivityLogDetail = async (id) => {
  return await apiClient(`/admin/activity-logs/${id}`, { method: 'GET' }, true);
};

export const getMethodLabel = (method) => method || '-';